import { useCallback } from "react";
import { getSupabase } from "@/lib/supabase";

export function useDealerLog() {
  const logAction = useCallback(
    async (
      dealerId: string,
      dealerUserId: string | null,
      action: string,
      details: string,
    ) => {
      try {
        const supabase = getSupabase();
        const { error } = await supabase.from("dealer_logs").insert({
          dealer_id: dealerId,
          dealer_user_id: dealerUserId,
          action,
          details,
          ip_address: null,
        });
        if (error) {
          console.error("Log yazma hatası:", error.message);
        }
      } catch (e: any) {
        console.error("Log yazma hatası:", e.message || e);
      }
    },
    [],
  );

  return { logAction };
}

export const LOG_ACTIONS = {
  LOGIN: "Giriş",
  LOGOUT: "Çıkış",
  PRODUCT_ADD: "Ürün Ekleme",
  PRODUCT_UPDATE: "Ürün Güncelleme",
  PRODUCT_DELETE: "Ürün Silme",
  CATEGORY_ADD: "Kategori Ekleme",
  CATEGORY_UPDATE: "Kategori Güncelleme",
  CATEGORY_DELETE: "Kategori Silme",
  SALE_CREATE: "Satış Oluşturma",
  SALE_UPDATE: "Satış Düzenleme",
  SALE_DELETE: "Satış Silme",
  PAYMENT_COLLECT: "Tahsilat",
  STAFF_ADD: "Personel Ekleme",
  STAFF_UPDATE: "Personel Güncelleme",
  STAFF_DELETE: "Personel Silme",
  BRANCH_ADD: "Şube Ekleme",
  BRANCH_UPDATE: "Şube Güncelleme",
  BRANCH_DELETE: "Şube Silme",
  SUPPLIER_ADD: "Tedarikçi Ekleme",
  SUPPLIER_UPDATE: "Tedarikçi Güncelleme",
  SUPPLIER_DELETE: "Tedarikçi Silme",
  DEALER_ADD: "Cari Bayi Ekleme",
  DEALER_UPDATE: "Cari Bayi Güncelleme",
  DEALER_DELETE: "Cari Bayi Silme",
  STOCK_UPDATE: "Stok Güncelleme",
  IMPORT: "Veri İçe Aktarma",
  SETTINGS_UPDATE: "Ayarları Güncelleme",
  CURRENCY_UPDATE: "Para Birimi Güncelleme",
  BANK_ACCOUNT_ADD: "Banka Hesabı Ekleme",
  BANK_ACCOUNT_UPDATE: "Banka Hesabı Güncelleme",
  BANK_ACCOUNT_DELETE: "Banka Hesabı Silme",
  USER_ADD: "Kullanıcı Ekleme",
  USER_UPDATE: "Kullanıcı Güncelleme",
  USER_DELETE: "Kullanıcı Silme",
  BACKUP: "Yedekleme",
  PAYMENT_NOTIFICATION: "Ödeme Bildirimi",
} as const;